<ng-container>
    <div class="row search-part">
        <div class="col-md-12 col-sm-12 mb-0">
            <div class="row">
                <div class="col-md-11 col-sm-12 mb-0">
                    <input 
                        class="form-control custom-input" 
                        placeholder="Rechercher par le nom du médicament" 
                        autocomplete="off"
                        [(ngModel)]="itemToSearch.searchText" 
                        (keyup)="getItems()" 
                        name="searchText" 
                        type="text" 
                        [disabled]="isDisabled"
                    >
                </div>
                <div class="col-md-1 p-0" *ngIf="(itemSelected && itemSelected?.id) || itemToSearch.searchText">
                    <button 
                        type="button" 
                        class="btn btn-default btn-xs btn-close-item pull-right" 
                        title="Vider" 
                        (click)="clearSelection()"
                        [disabled]="isDisabled"
                    >
                        <i class="fa fa-times"></i> 
                    </button>  
                </div>
            </div>
           
            <div class="search-results" *ngIf="canDisplay">
                <div class="search-results-header">
                    <div class="status-legend">
                        <div class="legend-item">
                            <div class="legend-dot excluded"></div>
                            <span>Exclu</span>
                        </div>
                        <div class="legend-item">
                            <div class="legend-dot prior-agreement"></div>
                            <span>Entente préalable</span>
                        </div>
                        <div class="legend-item">
                            <div class="legend-dot available"></div>
                            <span>Disponible</span>
                        </div>
                    </div>
                    Médicaments disponibles
                </div>

                <div class="medications-container" (scroll)="onScroll($event)">
                    <div 
                        *ngFor="let item of listItem; let indice = index" 
                        class="medication-item"
                        [ngClass]="getMedicationStatusClass(item)"
                        (click)="selectedItem(item)"
                    >
                        <div class="item-number">{{ indice + 1 }}</div>
                        <div class="item-content" [innerHTML]="item.styled"></div>
                        <div class="status-indicator"></div>
                    </div>

                    <div *ngIf="!listItem || listItem.length == 0" class="no-data">
                        <i class="fa fa-search"></i>
                        <span>Aucune donnée disponible</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>